import { FieldInformationType } from './field-information-type.enum';

export class FieldInformation {
  name = '';
  title = '';
  description = '';
  type = FieldInformationType.unknown;
  isRequired: false;
  isReadonly: false;

  static createFromAny(data: any): FieldInformation {
    const fieldInformation = new FieldInformation();
    fieldInformation.name = data.name;
    fieldInformation.title = data.title;
    fieldInformation.description = data.description || data.title;
    const filedType = data.type as string;
    if (filedType) {
      fieldInformation.type = FieldInformationType[filedType];
    }
    fieldInformation.isRequired = data.isRequired;
    fieldInformation.isReadonly = data.isReadonly;
    return fieldInformation;
  }

  static createFromAnyArray(data: any): FieldInformation[] {
    if (!data) {
      return [];
    }
    return data.map(field => FieldInformation.createFromAny(field));
  }
}
